import axios from 'axios'
import { getCookie } from '~/js/cookies'
import { ID_DATA } from '~/js/constants/data-element-ids'

export const getUuid = async ({ employeeId } = {}) => {
  const elementData = document.getElementById(ID_DATA)
  const endpointUuid = elementData.dataset.endpointZetaUuid
  const siteId = elementData.dataset.zetaSiteId
  const fk =
    employeeId || elementData.dataset.customerId || getCookie('_shopify_y')

  const response = await axios.get(endpointUuid, {
    params: {
      fk,
      site: siteId,
    },
  })
  return response.data.uuid
}
